import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import assessmentReducer from './assessmentSlice';
import userReducer from './userSlice';
import promptReducer from './promptSlice';
import leaderReducer from './leaderSlice';
import leaderInsightReducer from './leaderInsightSlice';
import { resetAllState } from '../resetActions'; // adjust path as needed

const appReducer = combineReducers({
    auth: authReducer,
    assessment: assessmentReducer,
    user: userReducer,
    prompt: promptReducer,
    leader: leaderReducer,
    leaderInsight: leaderInsightReducer,
});

const rootReducer = (state, action) => {
    if (action.type === resetAllState.type) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;